"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormErrorMessage from "./webflow_modules/Form/components/FormErrorMessage";
import FormForm from "./webflow_modules/Form/components/FormForm";
import FormSuccessMessage from "./webflow_modules/Form/components/FormSuccessMessage";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";
import FormWrapper from "./webflow_modules/Form/components/FormWrapper";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import { SearchInputClearButton } from "./SearchInputClearButton";
import { SearchInputPopoverHeading } from "./SearchInputPopoverHeading";
import { SearchModalResultCommunityAndMarket } from "./SearchModalResultCommunityAndMarket";

export function SearchInputHomePage({
  children = "",
  clearSearchProps = {},
  inputProps = {},
  showClear = true,
  showPopover = true,
}) {
  return (
    <Block tag={"div"}>
      <FormWrapper className={"hero-form_block"}>
        <FormForm
          className={"hero-form_form"}
          data-name={"Home Hero Form"}
          id={"wf-form-Home-Hero-Form"}
          method={"get"}
          name={"wf-form-Home-Hero-Form"}
        >
          <Block className={"div-block-103"} tag={"div"}>
            <Block className={"hero-form_form-wrapper"} tag={"div"}>
              <Block className={"div-block-47"} tag={"div"}>
                <Block className={"search-left"} tag={"div"}>
                  <Block className={"div-block-102"} tag={"div"}>
                    <HtmlEmbed
                      className={"html-embed-8"}
                      content={
                        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n  <path fill="currentColor" d="M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"/></svg>'
                      }
                    />
                  </Block>
                  <FormTextInput
                    // @ts-ignore - User-defined custom attribute(s)
                    autoComplete={"off"}
                    autoFocus={false}
                    className={"hero-form_text-field"}
                    data-name={"Name 3"}
                    disabled={false}
                    id={"search-input"}
                    maxLength={256}
                    name={"name-3"}
                    placeholder={"Search by location or community"}
                    required={false}
                    tabIndex={0}
                    type={"text"}
                    {...inputProps}
                  />
                  <Block className={"search-block-clear-input"} tag={"div"}>
                    <SearchInputClearButton
                      clearSearchProps={{
                        ...clearSearchProps,
                      }}
                      showClearButton={showClear}
                    />
                  </Block>
                </Block>
                <Block className={"search-fake-submit-button"} tag={"div"}>
                  <Block className={"submit-button-copy"} tag={"div"}>
                    <Block tag={"div"}>{"Search"}</Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Block>
          {showPopover ? (
            <Block
              className={"search-input-popover-home-page-copy-copy"}
              tag={"div"}
            >
              <Block className={"search-results-large"} tag={"div"}>
                <Block className={"search-results-container"} tag={"div"}>
                  <Block className={"search-input-slot-results"} tag={"div"}>
                    {children ?? (
                      <>
                        <SearchInputPopoverHeading />
                        <SearchModalResultCommunityAndMarket />
                        <SearchModalResultCommunityAndMarket />
                        <SearchModalResultCommunityAndMarket />
                        <SearchModalResultCommunityAndMarket />
                        <SearchModalResultCommunityAndMarket />
                        <SearchInputPopoverHeading text={"OUR Communities"} />
                        <SearchModalResultCommunityAndMarket showImage={true} />
                        <SearchModalResultCommunityAndMarket showImage={true} />
                        <SearchModalResultCommunityAndMarket showImage={true} />
                        <SearchModalResultCommunityAndMarket showImage={true} />
                        <SearchModalResultCommunityAndMarket showImage={true} />
                        <SearchModalResultCommunityAndMarket showImage={true} />
                      </>
                    )}
                  </Block>
                </Block>
                <Block className={"search-results-color-block"} tag={"div"} />
              </Block>
            </Block>
          ) : null}
        </FormForm>
        <FormSuccessMessage />
        <FormErrorMessage />
      </FormWrapper>
    </Block>
  );
}
